import React from "react";
import {StatisticsForProductsContainer} from '../../components/containers/StatisticsForProductsContainer';

export function ProductsStatisticsPage() {
  return <StatisticsForProductsContainer />;
}
